import FORM_CHECKBOX_CLASS_NAME from '../../constants/checkbox';

export const checkboxStyles = ({ theme, checkedColor }) => ({
  color: theme.palette.gray.A400,
  '&.Mui-checked': {
    color: checkedColor,
  },
  '&.MuiCheckbox-indeterminate': {
    color: checkedColor,
  },
  '&.Mui-disabled': {
    color: theme.palette.gray.A300,
    opacity: 0.6,
  },
});

const MuiCheckbox = {
  styleOverrides: {
    root: ({ theme }) => ({
      [`&.${FORM_CHECKBOX_CLASS_NAME}`]: checkboxStyles({
        theme,
        checkedColor: theme.palette.primary.main,
      }),
    }),
  },
};

export default MuiCheckbox;
